export const config = {
  contentful: {
    apiUrl: 'https://cdn.contentful.com/spaces/k92fldv75np5/entries',
    accessToken: 'GBmkx9S7sbqmcEQxPH9FN2qvKdUdUXIlQ5EWeTSDAa8',
  },
};


/**
 * Current SPYSCAPE venues
 * Used in the Navbar and FlyoutMenu to display ticket links
 * */
export const VENUE_BUTTONS = [
  {
    name: 'New York',
    url: 'https://spyscape.com/tickets-new-york',
  },
  {
    name: 'London',
    url: 'https://feverup.com/m/345866?thm=3632&_gl=1*cifiyl*_gcl_au*MTQzMTM0MTE3My4xNzQ0Njk1NTc4',
  },
];
